<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <div class="modal-card select-rule-modal-card">
      <header class="modal-card-head">
        <h1 class="is-title-header modal-card-title">Select Rule</h1>
      </header>
      <section class="modal-card-body select-rule-modal-body">
        <div class="columns">
          <div class="column">
            <b-field>
              <multiselect
                v-model="selectedRule"
                :options="rules"
                placeholder="Select"
                label="name"
                track-by="name"
                :searchable="true"
                :multiple="false"
                :show-labels="false"
                :maxHeight="160"
              >
                <span
                  class="checkbox-label"
                  slot="option"
                  slot-scope="scope"
                  :title="scope.option.name"
                >
                  <div class="customToolTips">
                    {{ scope.option.name }}
                    <span class="tooltiptext"
                      ><view-tree :node="scope.option.rule_json"></view-tree
                    ></span>
                  </div>
                </span>
              </multiselect>
            </b-field>
            <b-field v-if="showPriority">
              <multiselect
                v-model="priority"
                :options="priorityOptions"
                placeholder="Select"
                label="value"
                track-by="value"
                required
              ></multiselect>
              <!-- <b-select
                name="priority"
                v-model="priority"
                placeholder="Select Priority"
                expanded
              >
                <option value="normal" selected>Normal Priority</option>
                <option value="high">High Priority</option>
                <option value="low">Low Priority</option>
              </b-select> -->
            </b-field>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button
          slot="right"
          native-type="submit"
          type="is-primary"
          v-on:click="selectRule"
        >
          Select
        </b-button>
        <b-button slot="right" class="is-normal" @click="cancel">
          Cancel
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import Multiselect from "vue-multiselect";
import UtilityMixin from "@/mixins/UtilityMixin";
import scopeMixin from "@/mixins/scopeMixin";
import RulesManagerService from "../../services/RulesManagerService";
import ViewTree from "@/components/RulesManager/ViewTree.vue";
// @group Dashboard
export default {
  name: "SelectRule",
  mixins: [UtilityMixin, scopeMixin],
  components: { Multiselect, ViewTree },
  props: {
    viewOnly: {
      type: Boolean,
      default: true
    },
    isActive: {
      type: Boolean,
      default: false
    },
    showPriority: {
      type: Boolean,
      default: false
    },
    stream: {
      type: Number,
      default: null
    }
  },

  data() {
    return {
      rules: [],
      isModalActive: false,
      loading: "",
      selectedRule: null,
      RulesManagerService: new RulesManagerService(),
      priority: null,
      priorityOptions: [
        { name: "normal", value: "Normal Priority" },
        { name: "high", value: "High Priority" },
        { name: "low", value: "Low Priority" }
      ]
    };
  },
  mounted() {
    this.getRuleList();
  },
  methods: {
    getRuleList() {
      this.RulesManagerService.getAllRules(this.stream).subscribe(response => {
        this.rules = response;
      });
    },
    selectRule() {
      if (this.selectedRule) {
        this.showPriority
          ? this.$emit(
              "confirm",
              this.selectedRule,
              this.priority ? this.priority.name : ""
            )
          : this.$emit("confirm", this.selectedRule);
      } else {
        this.$buefy.toast.open({
          message: "Please, Select a rule first",
          type: "is-warning"
        });
      }
    },
    cancel() {
      this.selectedRule = null;
      this.priority = null;
      this.$emit("cancel");
    },

    submit() {
      this.$emit("addNew");
    }
  },
  watch: {
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    }
  }
};
</script>
